import skills_Firebase from '../assets/images/skills/Firebase.svg';
import experiences_DomainSSL from '../assets/images/experiences/DomainSSL.png';
import experiences_lionsclub from '../assets/images/experiences/lionsclub.jpg';
import experiences_npui from '../assets/images/experiences/npui.png';
import experiences_npuillp from '../assets/images/experiences/npuillp.png';
import experiences_freelance from '../assets/images/experiences/freelance.jpg';
import certification_DomainSSL from '../assets/images/certification/DomainSSL.png';
// import education_DomainSSL from '../assets/images/education/DomainSSL.svg';
// import certification_VivekamSeniorSecondarySchoolCoimbatore from '../assets/images/certification/VivekamSeniorSecondarySchoolCoimbatore.svg';
import certification_HarvardX from '../assets/images/certification/HarvardX.png';
import certification_Kaggle from '../assets/images/certification/Kaggle.png';
import certification_InfosysSpringboard from '../assets/images/certification/InfosysSpringboard.png';
import skills_HTML5 from '../assets/images/skills/HTML5.png';
import skills_Nodejs from '../assets/images/skills/Nodejs.png';
import skills_PostgreSQL from '../assets/images/skills/PostgreSQL.png';
import skills_MaterialUI from '../assets/images/skills/MaterialUI.png';
import skills_FLStudio from '../assets/images/skills/FLStudio.png';
import education_HarvardX from '../assets/images/education/HarvardX.png';
import education_SriKrishnaCollegeofEngineeringandTechnologyCoimbatore from '../assets/images/education/SriKrishnaCollegeofEngineeringandTechnologyCoimbatore.png';
import education_VivekamSeniorSecondarySchoolCoimbatore from '../assets/images/education/VivekamSeniorSecondarySchoolCoimbatore.png';
import projects_LumaAITherapist from '../assets/images/projects/LumaAITherapist.png';
import projects_Vyla from '../assets/images/projects/Vyla.png';
import projects_LumaAITherapist_thumb from '../assets/images/projects/LumaAITherapist_thumb.png';
import projects_CGPACalculator from '../assets/images/projects/CGPACalculator.png';
import projects_CGPACalculator_thumb from '../assets/images/projects/CGPACalculator_thumb.png';
import projects_TripNexAITripPlanner from '../assets/images/projects/TripNexAITripPlanner.png';
import projects_TripNexAITripPlanner_thumb from '../assets/images/projects/TripNexAITripPlanner_thumb.png';
import projects_CodexAICodeReviewer from '../assets/images/projects/CodexAICodeReviewer.png';
import projects_CodexAICodeReviewer_thumb from '../assets/images/projects/CodexAICodeReviewer_thumb.png';
import projects_InstagramEngagementRateCalculator from '../assets/images/projects/InstagramEngagementRateCalculator.png';
import projects_InstagramEngagementRateCalculator_thumb from '../assets/images/projects/InstagramEngagementRateCalculator_thumb.png';
import projects_ValorantTracker from '../assets/images/projects/ValorantTracker.png';
import projects_ValorantTracker_thumb from '../assets/images/projects/ValorantTracker_thumb.png';
import projects_NetflixClone from '../assets/images/projects/NetflixClone.png';
import projects_NetflixClone_thumb from '../assets/images/projects/NetflixClone_thumb.png';
import projects_Nioxo from '../assets/images/projects/Nioxo.png';
import projects_Nioxo_thumb from '../assets/images/projects/Nioxo_thumb.png';
import projects_TrackMyExpense from '../assets/images/projects/TrackMyExpense.png';
import projects_TrackMyExpense_thumb from '../assets/images/projects/TrackMyExpense_thumb.png';
import projects_SimpleCounter from '../assets/images/projects/SimpleCounter.png';
import projects_SimpleCounter_thumb from '../assets/images/projects/SimpleCounter_thumb.png';
import projects_Passwd from '../assets/images/projects/Passwd.png';
import projects_Passwd_thumb from '../assets/images/projects/Passwd_thumb.png';
import projects_PepsiPoster from '../assets/images/projects/PepsiPoster.png';
import projects_PepsiPoster_thumb from '../assets/images/projects/PepsiPoster_thumb.png';
import projects_AnirudhPoster from '../assets/images/projects/AnirudhPoster.png';
import projects_AnirudhPoster_thumb from '../assets/images/projects/AnirudhPoster_thumb.png';
import projects_DigitalTypography from '../assets/images/projects/DigitalTypography.png';
import projects_DigitalTypography_thumb from '../assets/images/projects/DigitalTypography_thumb.png';

export const Bio = {
  name: "Naveen Kumar",
  roles: [
    "Full-Stack Developer",
    "Android Developer",
    "Flutter Developer",
    "Python Developer",
    "Graphic Designer",
  ],
  description:
    "A Computer Science Engineering student with strong experience in full-stack development, backend systems, and automation. Built and shipped production-ready web, mobile, and AI-powered tools. Freelancing since age 14 with seven-figure revenue through software services and digital tools.",
  github: "https://github.com/iamNVN",
  resume:
    "https://iamnvn.in/static/files/resume.pdf",
  telegram: "https://telegram.me/iamNVN/",
  leetcode: "https://leetcode.com/iamnvn/",
  insta: "https://www.instagram.com/iam_nvn_/",
  email: "mailto:nvnkumaredu@gmail.com",
  facebook: "https://www.facebook.com/rishav.chanda.165/",
};
export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "HTML5",
        image: skills_HTML5,
      },
      {
        name: "CSS3",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript (ES6+)",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "React.js",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/React-icon.svg/150px-React-icon.svg.png",
      },
      {
        name: "Tailwind CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/Tailwind_CSS_Logo.svg/256px-Tailwind_CSS_Logo.svg.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
    ],
  },

  {
    title: "Backend",
    skills: [
      {
        name: "Node.js",
        image: skills_Nodejs,
      },
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "PHP",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/php/php-original.svg",
      },
      {
        name: "Flask",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/flask/flask-original.svg",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "PostgreSQL",
        image: skills_PostgreSQL,
      },
      {
        name: "Firebase",
        image: skills_Firebase,
      },
      {
        name: "Supabase",
        image:
          "https://logowik.com/content/uploads/images/supabase-icon1721342077.logowik.com.webp",
      },
    ],
  },

  {
    title: "Mobile Development",
    skills: [
      {
        name: "Flutter",
        image:
          "https://cdn-images-1.medium.com/max/1200/1*5-aoK8IBmXve5whBQM90GA.png",
      },
      {
        name: "Dart",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/c/c6/Dart_logo.png",
      },
      {
        name: "Material UI",
        image: skills_MaterialUI,
      },
      {
        name: "Android Studio",
        image:
          "https://developer.android.com/static/studio/images/new-studio-logo-1_1920.png",
      },
    ],
  },

  {
    title: "Design & Creative",
    skills: [
      {
        name: "Adobe Photoshop",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/photoshop/photoshop-original.svg",
      },
      {
        name: "Adobe Premiere Pro",
        image:
          "https://uxwing.com/wp-content/themes/uxwing/download/brands-and-social-media/adobe-premiere-pro-icon.png",
      },
      {
        name: "Adobe After Effects",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cb/Adobe_After_Effects_CC_icon.svg/512px-Adobe_After_Effects_CC_icon.svg.png",
      },
      {
        name: "Blender",
        image:
          "https://uxwing.com/wp-content/themes/uxwing/download/brands-and-social-media/blender-icon.svg",
      },
      {
        name: "FL Studio",
        image: skills_FLStudio,
      },
    ],
  },

  {
    title: "Tools & Platforms",
    skills: [
      {
        name: "Git",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/git/git-original.svg",
      },
      {
        name: "GitHub",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/github/github-original.svg",
      },
      {
        name: "VS Code",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/vscode/vscode-original.svg",
      },
      {
        name: "Anti Gravity IDE",
        image:
          "https://antigravity.google/assets/image/blog/blog-feature-introducing-google-antigravity.png",
      },
      {
        name: "Notion",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/notion/notion-original.svg",
      },
    ],
  },

  {
    title: "DevOps & Deployment",
    skills: [
      {
        name: "VPS",
        image:
          "https://img.freepik.com/premium-vector/vps-virtual-private-server-web-hosting-services-infrastructure-technology-vector-stock-illustration_100456-12121.jpg?semt=ais_hybrid&w=740&q=80",
      },
      {
        name: "Docker",
        image:
          "https://cdn-icons-png.flaticon.com/512/919/919853.png",
      },
      {
        name: "AWS",
        image:
          "https://registry.npmmirror.com/@lobehub/icons-static-png/1.75.0/files/dark/aws.png",
      },
      {
        name: "Microsoft Azure",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/azure/azure-original.svg",
      },
      {
        name: "Apache",
        image:
          "https://images.seeklogo.com/logo-png/31/2/apache-logo-png_seeklogo-314278.png",
      },
      {
        name: "cPanel",
        image:
          "https://images.seeklogo.com/logo-png/64/2/cpanel-icon-logo-png_seeklogo-649248.png",
      },
      {
        name: "GitHub Actions",
        image:
          "https://avatars.githubusercontent.com/u/44036562?s=200&v=4",
      },
      // {
      //   name: "FTP",
      //   image:
      //     "https://cdn-icons-png.flaticon.com/512/873/873107.png",
      // },
      // {
      //   name: "Domain & SSL",
      //   image:
      //     "https://cdn-icons-png.flaticon.com/512/942/942748.png",
      // },
    ],
  },
];


export const experiences = [
  {
    id: 101,
    img: experiences_lionsclub,
    role: "Treasurer",
    company: "Lions Club of Coimbatore Semmozhi",
    date: "Jul 2026 - Present",
    desc: "Managing club finances and treasury records, maintaining transparent income and expense statements while assisting in budgeting and fund management for community service initiatives.",
  },
  {
    id: 102,
    img: experiences_npui,
    role: "State Secretary, Tamil Nadu",
    company: "National Press Union of India",
    date: "May 2026 - Present",
    desc: "Leading Tamil Nadu state operations and strategic initiatives. Establishing state-wide wings, executing state-wide campaigns, recruiting and appointing office bearers and coordinators, overseeing branding, digital presence, and public communications, and coordinating partnerships and networking with media professionals across the state.",
  },
  {
    id: 103,
    img: experiences_npuillp,
    role: "Director",
    company: "NPUI Media Network LLP",
    date: "Apr 2026 - Present",
    desc: "Directing the company's strategic operations, business development, and organizational growth. Coordinating legal, operational, and compliance-related activities. Overseeing branding, compliance, and stakeholder relationships to drive expansion.",
  },
  {
    id: 104,
    img: experiences_npuillp,
    role: "Lead Developer",
    company: "NPUI Media Network LLP",
    date: "Apr 2026 - Present",
    desc: "Leading the design and development of the company's technology platforms. Architecting and developing full-stack applications, managing cloud infrastructure, and overseeing API integrations and security implementations.",
  },
  {
    id: 105,
    img: experiences_freelance,
    role: "Developer (Freelance)",
    company: "Self-Employed",
    date: "Dec 2021 - Present",
    desc: "Building custom software solutions, websites, and automation systems. Developing full-stack web applications and REST APIs using technologies like React, Node.js, Python, and cloud platforms.",
  },
];

export const education = [
  // {
  //   id: 2,
  //   img: education_DomainSSL,
  //   school: "HarvardX",
  //   date: "2024",
  //   grade: "none",
  //   degree: "Other; Certificate in CS50’s Introduction to Programming with Python",
  // },
  {
    id: 2,
    img: education_HarvardX,
    school: "Sri Krishna College of Engineering and Technology, Coimbatore",
    date: "2024 - 2028",
    grade: "8.22 CGPA (Till SEM 4)",
    degree: "B.E Computer Science Engineering",
  },
  {
    id: 1,
    img: education_SriKrishnaCollegeofEngineeringandTechnologyCoimbatore,
    school: "Vivekam Senior Secondary School, Coimbatore",
    date: "Apr 2023 - Apr 2024",
    grade: "90.4%",
    degree: "CBSE(XII), PCM with Computer Science",
  },
  {
    id: 0,
    img: education_VivekamSeniorSecondarySchoolCoimbatore,
    school: "Vivekam Senior Secondary School, Coimbatore",
    date: "Apr 2021 - Apr 2022",
    grade: "87.2%",
    degree: "CBSE(X)",
  },
]; export const certification = [
  {
    id: 0,
    img: certification_HarvardX,
    school: "HarvardX",
    site: "https://www.harvardonline.harvard.edu/course/cs50s-introduction-programming-python",
    date: "2024",
    degree: "CS50 - Introduction to Programming with Python",
  },
  {
    id: 1,
    img: certification_Kaggle,
    school: "Kaggle",
    site: "https://www.kaggle.com/learn/certification/tanztechnologies/python",
    date: "2024",
    degree: "Python",
  },
  {
    id: 2,
    img: certification_InfosysSpringboard,
    school: "Infosys Springboard",
    site: "https://iamnvn.in/static/files/projectonhtmlcss-infosys.pdf",
    date: "2024",
    degree: "Project On HTML CSS",
  },
  {
    id: 3,
    img: certification_InfosysSpringboard,
    school: "Infosys Springboard",
    site: "https://iamnvn.in/static/files/moderncppchallenger-infosys.pdf",
    date: "2024",
    degree: "The Modern C++ Challenger",
  },
  {
    id: 4,
    img: certification_InfosysSpringboard,
    school: "Infosys Springboard",
    site: "https://iamnvn.in/static/files/multiparadigrim-infosys.pdf",
    date: "2024",
    degree: "Multi-Paradigm Programming with Modern C++",
  },
];


export const projects = [
  {
    id: 17,
    title: "Vyla – SMS Expense Tracker",
    date: "January 2026",
    description:
      "Vyla is a privacy-first Android expense tracker that automatically logs expenses from bank SMS alerts. All data is stored locally on the device with no cloud sync or accounts. Designed for reliable, offline-first money management.",
    image: projects_Vyla,
    thumb: projects_Vyla,
    category: ["android app"],
    buttons: [{ title: "View on Play Store", url: "https://play.google.com/store/apps/details?id=in.iamnvn.vyla" }],
  },{
    id: 16,
    title: "Luma - AI Therapist",
    date: "July 2025",
    description:
      "Luma is an AI-powered voice-first therapist experience that blends real-time speech, streaming AI replies, and seamless text-audio sync. Built with AssemblyAI, ElevenLabs, and Supabase, it redefines responsive, conversational interaction.",
    image: projects_LumaAITherapist,
    thumb: projects_LumaAITherapist_thumb,
    category: ["web app"],
    buttons: [{ title: "View Live App", url: "https://luma.iamnvn.in/" }],
  },
  {
    id: 15,
    title: "MelodyMystery",
    date: "June 2025",
    description:
      "A fun music guessing game with progressive audio reveals and smart search. Built using React, Tailwind, and the JioSaavn API for real-time song previews.",
    image:
      "https://iamnvn.in/static/media/Screenshot%202025-05-15%20224417.png",
    thumb:
      "https://iamnvn.in/static/media/Screenshot%202025-05-15%20224417.png",
    category: ["web app"],
    buttons: [
      { title: "View Live App", url: "https://melodymystery.iamnvn.in/" },
    ],
  },
  {
    id: 14,
    title: "CGPA Calculator",
    date: "February 2025",
    description:
      "CGPA calculator that accurately calculates your cumulative GPA while tracking past and current semester grades",
    image: projects_CGPACalculator,
    thumb: projects_CGPACalculator_thumb,
    category: ["web app"],
    buttons: [{ title: "View Live App", url: "https://cgpa.iamnvn.in/" }],
  },
  {
    id: 13,
    title: "TripNex - AI Trip Planner",
    date: "February 2025",
    description:
      "An AI-based travel planner that creates personalized itineraries based on your preferences and needs",
    image: projects_TripNexAITripPlanner,
    thumb: projects_TripNexAITripPlanner_thumb,
    category: ["web app"],
    buttons: [{ title: "View Live App", url: "https://tripnex.iamnvn.in/" }],
  },
  {
    id: 12,
    title: "Codex - AI Code Reviewer",
    date: "January 2025",
    description:
      "An AI-powered code reviewer that detects bugs, identifies security issues, and provides a rating to help improve the quality and reliability of your code",
    image: projects_CodexAICodeReviewer,
    thumb: projects_CodexAICodeReviewer_thumb,
    category: ["web app"],
    buttons: [{ title: "View Live App", url: "https://codex.iamnvn.in/" }],
  },
  {
    id: 11,
    title: "Instagram Engagement Rate Calculator",
    date: "December 2024",
    description:
      "The Instagram Engagement Rate Calculator analyzes your account's engagement based on followers, likes, and comments",
    image: projects_InstagramEngagementRateCalculator,
    thumb: projects_InstagramEngagementRateCalculator_thumb,
    category: ["web app"],
    buttons: [
      {
        title: "View Live App",
        url: "https://tools.iamnvn.in/instagram-engagement-calculator/",
      },
    ],
  },
  {
    id: 10,
    title: "Valorant Tracker",
    date: "April 2024",
    description:
      "Valorant Tracker: Live player stats, match history, and detailed match stats. Track your progress and outplay the competition.",
    image: projects_ValorantTracker,
    thumb: projects_ValorantTracker_thumb,
    category: ["web app"],
    buttons: [{ title: "View Live App", url: "https://valorant.iamnvn.in" }],
  },
  {
    id: 9,
    title: "Netflix Clone",
    date: "June 2023",
    description:
      "A netflix clone made with Flutter. It has a details page, list-wise categorization, coming soon and downloads page (only on mobile). It fetches Movie/TV Show details and episodes from themoviedb API. Experience smooth navigation, responsive layouts, and an engaging UI mirroring the original platform.",
    image: projects_NetflixClone,
    thumb: projects_NetflixClone_thumb,
    category: ["web app"],
    buttons: [
      { title: "View Web App", url: "https://nvnflix.iamnvn.in/" },
    ],
  },
  {
    id: 8,
    title: "Nioxo",
    date: "June 2023",
    description:
      "Nioxo is an API Provider. It includes Email Validator, IP Address Validator, Number Validator, Credit Card Generator, Currency Convert, IFSC Details API and Bin Details API. It comes with a free plan as well as a premium plan for upgraded benefits.",
    image: projects_Nioxo,
    thumb: projects_Nioxo_thumb,
    category: ["web app"],
    buttons: [{ title: "Coming Soon", url: "#" }],
  },
  {
    id: 7,
    title: "TrackMyExpense",
    date: "March 2024",
    description:
      "TrackMyExpense is a finance management web app designed to empower users with secure, intuitive, and comprehensive tools for tracking expenses and budgeting. Tracking your spending is often the first step to getting your finances in order and TrackMyExpense seamlessly integrates it into your daily routine.",
    image: projects_TrackMyExpense,
    thumb: projects_TrackMyExpense_thumb,
    category: ["web app"],
    buttons: [{ title: "View Web App", url: "https://tme.iamnvn.in" }],
  },
  {
    id: 6,
    title: "Simple Counter",
    date: "April 2023",
    description:
      "Simple Counter is free counter app designed for counting people and keeping track of numbers.",
    image: projects_SimpleCounter,
    thumb: projects_SimpleCounter_thumb,
    category: ["android app", "web app"],
    buttons: [
      { title: "View Web App", url: "https://counter.iamnvn.in" },
      {
        title: "View Android App",
        url: "https://play.google.com/store/apps/details?id=tech.invn.simplecounter",
      },
    ],
  },
  {
    id: 5,
    title: "Passwd.",
    date: "May 2023",
    description:
      "Passwd is a beautiful password manager built using Flutter. It simplifies the process of storing passwords.",
    image: projects_Passwd,
    thumb: projects_Passwd_thumb,
    category: ["android app"],
    buttons: [
      {
        title: "View Android App",
        url: "https://play.google.com/store/apps/details?id=tech.invn.passwd",
      },
    ],
  },
  {
    id: 4,
    title: "Pepsi Poster",
    date: "November 2023",
    description: "Digital Artwork created with Adobe Photoshop.",
    image: projects_PepsiPoster,
    thumb: projects_PepsiPoster_thumb,
    category: ["digital artwork"],
    buttons: [
      {
        title: "View Full Image",
        url: "https://iamnvn.in/digitalart/pepsi.png",
      },
    ],
  },
  {
    id: 3,
    title: "Anirudh Poster",
    date: "November 2023",
    description: "Digital Artwork created with Adobe Photoshop.",
    image: projects_AnirudhPoster,
    thumb: projects_AnirudhPoster_thumb,
    category: ["digital artwork"],
    buttons: [
      {
        title: "View Full Image",
        url: "https://iamnvn.in/digitalart/anirudh.png",
      },
    ],
  },
  {
    id: 2,
    title: "Digital Typography",
    date: "November 2023",
    description: "Digital Artwork created with Adobe Photoshop.",
    image: projects_DigitalTypography,
    thumb: projects_DigitalTypography_thumb,
    category: ["digital artwork"],
    buttons: [
      {
        title: "View Full Image",
        url: "https://iamnvn.in/digitalart/runaway.png",
      },
    ],
  },
  {
    id: 1,
    title: "Digital Typography",
    date: "December 2023",
    description: "Digital Artwork created with Adobe Photoshop.",
    image: projects_DigitalTypography,
    thumb: projects_DigitalTypography_thumb,
    category: ["digital artwork"],
    buttons: [
      {
        title: "View Full Image",
        url: "https://iamnvn.in/digitalart/oversoon.png",
      },
    ],
  },
  {
    id: 0,
    title: "Digital Typography",
    date: "December 2023",
    description: "Digital Artwork created with Adobe Photoshop.",
    image: projects_DigitalTypography,
    thumb: projects_DigitalTypography_thumb,
    category: ["digital artwork"],
    buttons: [
      {
        title: "View Full Image",
        url: "https://iamnvn.in/digitalart/everything.png",
      },
    ],
  },
];


export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];
